/**
 * Experiment for web desktop global navigation changes * #f-web-navigation
 */
export const DESKTOP_WEB_NAVIGATION_EXPERIMENT_240722 = 'DESKTOP_WEB_NAVIGATION_EXPERIMENT_240722';
